export enum OptionSource {
  Static = 'static',
  Industry = 'industry',
}
